<template>
  <div class="base_color">
    <div id="container">

      <div class="crossBox"><van-icon @click="close" class="cross" name="cross" /></div>
      <div class="clause">
        <div style="text-align: left !important;">
            <p style="line-height:22pt; margin:0pt; orphans:0; text-align:center; widows:0">
                <span style="font-family:宋体; font-size:22pt; font-weight:bold">个人</span>
                <span style="font-family:宋体; font-size:22pt; font-weight:bold">信息查询</span>
                <span style="font-family:宋体; font-size:22pt; font-weight:bold">及</span>
                <span style="font-family:宋体; font-size:22pt; font-weight:bold">使用</span>
                <span style="font-family:宋体; font-size:22pt; font-weight:bold">授权书</span>
            </p>
            <p style="line-height:22pt; margin:0pt; orphans:0; text-align:center; widows:0">
                <span style="font-family:宋体; font-size:22pt; font-weight:bold">&#xa0;</span>
            </p>
            <p style="line-height:20pt; margin:0pt; orphans:0; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">尊敬的客户：</span>
            </p>
            <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">为了维护您的权益，请在签署本授权书前，仔细阅读本授权书各条款（特别是黑体字条款），关注您对本行的授权内容。</span>
            </p>
            <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">如您对本授权书的内容有任何疑问，您可致电</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">投诉咨询</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">热线电话</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">95396</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">进行咨询，或者通过贷款人和/或贷款人线上服务平台、客户服务等进行咨询了解，以便为您解答和说明。一旦您通过点击或其他方式确认本授权书，即意味着您愿意接受本授权书条款约束。</span>
            </p>
            <p style="line-height:20pt; margin:0pt; orphans:0; widows:0">
                <span style="font-family:宋体; font-size:11pt">吉林亿联银行股份有限公司（以下简称：被授权人）:</span>
            </p>
            <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
                <span style="font-family:宋体; font-size:11pt">本人充分理解并同意，本贷款服务是吉林亿联银行股份有限公司（以下简称“亿联银行”）为本人提供的个人贷款服务，现本人主动申请开通此项服务，为客观、准确地评估本人的信用等级和授信额度，并为本人提供优质的服务，就使用本人的相关必要信息，本人同意并授权如下：</span>
            </p>
            <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:22pt; widows:0">
                <span style="font-family:宋体; font-size:11pt">一、</span>
                <span style="font-family:宋体; font-size:11pt">本人同意</span>
                <span style="font-family:宋体; font-size:11pt">并</span>
                <span style="font-family:宋体; font-size:11pt">授权</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">：</span>
                <span style="font-family:宋体; font-size:11pt">被授权人在办理</span>
                <span style="font-family:宋体; font-size:11pt">第</span>
                <span style="font-family:宋体; font-size:11pt">四</span>
                <span style="font-family:宋体; font-size:11pt">条</span>
                <span style="font-family:宋体; font-size:11pt">涉及到本人的业务时，</span>
                <span style="font-family:宋体; font-size:11pt">为信用评估、风险控制、逾期账款催收等与《</span>
                <span style="font-family:宋体; font-size:11pt">借款额度合同</span>
                <span style="font-family:宋体; font-size:11pt">》、《借款合同》</span>
                <span style="font-family:宋体; font-size:11pt">等</span>
                <span style="font-family:宋体; font-size:11pt">（以实际名称为准）履行相关的目的，</span>
                <span style="font-family:宋体; font-size:11pt">可以向中国人民银行金融信用信息基础数据库</span>
                <span style="font-family:宋体; font-size:11pt">、</span>
                <span style="font-family:宋体; font-size:11pt">百行征信有限公司、朴道征信有限公司等依法设立的征信机构或信用服务机构</span>
                <span style="font-family:宋体; font-size:11pt">查询、使用本人的信用信息和信用报告；收集在本人申请或使用授权业务过程中及还款期内，向被授权人提交的信息或新产生的信息；为了防范风险等合法目的，向合法留存本人信息的其他方（如被授权人的合作伙伴等，</span>
                <span style="font-family:宋体; font-size:11pt">具体合作伙伴范围等以被授权人网站/APP或其他公开渠道公布的名单为准</span>
                <span style="font-family:宋体; font-size:11pt">）收集或核验与授权业务相关的必要信息；向</span>
                <span style="font-family:宋体; font-size:11pt">公安部公民身份信息数据库</span>
                <span style="font-family:宋体; font-size:11pt">、通信运营商、社保、公积金、税务、电子商务平台、互联网平台等部分政府机构、司法机关、公共事业单位、行业组织、中国高等教育学生信息网等第三方权威机构采集与授权业务相关的必要信息。上述信息采集方式包括但不限于</span>
                <span style="font-family:宋体; font-size:11pt">查询、</span>
                <span style="font-family:宋体; font-size:11pt">核实、采集、整理、</span>
                <span style="font-family:宋体; font-size:11pt">打印、保存、</span>
                <span style="font-family:宋体; font-size:11pt">加工和</span>
                <span style="font-family:宋体; font-size:11pt">使用</span>
                <span style="font-family:宋体; font-size:11pt">等</span>
                <span style="font-family:宋体; font-size:11pt">符合法律法规规定的</span>
                <span style="font-family:宋体; font-size:11pt">方式；上述</span>
                <span style="font-family:宋体; font-size:11pt">本人个人</span>
                <span style="font-family:宋体; font-size:11pt">基本</span>
                <span style="font-family:宋体; font-size:11pt">信息</span>
                <span style="font-family:宋体; font-size:11pt">、信用信息和信用报告等包括但不限于</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">姓名、性别、国籍、职业、身份证件或身份证明文件种类、号码和有效期、联系电话、</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">地址、交通、通信、</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">IP地址和MAC地址、手机号归属、手机设备信息、手机号码、</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">债务、财产、支付、消费、生产经营、</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">社保信息、交易信息、信贷信息、</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">履行法定义务等信息，以及基于前述信息对个人信用状况形成的分析、评价类信息</span>
                <span style="font-family:宋体; font-size:11pt">。</span>
                <span style="font-family:宋体; font-size:11pt"></span>
            </p>
            <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:normal">二、本人同意</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:normal">并</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:normal">授权：</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">被授权人可以向</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:normal">中国人民银行金融信用信息基础数据库</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:normal">、</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:normal">百行征信有限公司、朴道征信有限公司等</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">依法设立的征信机构或信用服务机构提供本人的个人基础信息</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">（包括但不限于本人的基本信息、借贷信息、</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">履约风险信息、担保信息、商业保险信息、不动产信息、纳税信息、设备信息、实名验证信息、人脸识别结果、收入信息、消费信息、车辆信息</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">）</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">和信贷业务交易等相关信用信息（包括但不限于本人因未及时履行合同义务产生的不良信息）</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">。</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">本人知悉，被授权人向征信机构提供本人相关信息为其履行《征信业管理条例》第二十九条（即“向金融信用信息基础数据库提供信贷信息”）规定的义务所必须。且本人知悉，信用记录、信用报告或信用评分是国家机关、其他个人和机构对信用进行依法查询和/或提供服务或进行限制的参考依据</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">，</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">本人已经理解并知悉提供该等信息可能会对本人产生的影响。</span>
            </p>
            <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:normal">三</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:normal">、本人同意并授权：被授权人可收集、存储、使用、分析本人在注册、使用服务时，在</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:normal">被授权人</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:normal">的相关历史信息、支付数据信息和本人注册、使用</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:normal">被授权人</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:normal">软件产品产生的相关必要信息等，</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">包括但不限于所提供的姓名，身份证信息、影像，银行卡信息、影像，身份验证过程中产生的图像视频数据等相关身份信息</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:normal">以及使用本服务的相关操作及行为信息（例如，</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">操作记录、设备型号和配置、操作系统版本、设备配置、唯一设备标识符等软硬件特征信息，IP地址、GPS位置和基站等传感器信息等位置信息，及浏览器的类型、电信运营商、使用的语言、访问日期和时间以及访问时长等对服务的详细使用情况，作为有关网络日志保存</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:normal">）。本服务通过使用这些信息识别本人的身份，以便遵守国家相关法律法规的规定，为本人提供贷款服务。</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">上述信息属于涉及个人敏感信息，如本人拒绝提供上述信息，被授权人将无法为本人提供本服务，但不影响其为本人提供其他服务。</span>
            </p>
            <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
                <span style="font-family:宋体; font-size:11pt">四</span>
                <span style="font-family:宋体; font-size:11pt">、本人同意</span>
                <span style="font-family:宋体; font-size:11pt">被授权人</span>
                <span style="font-family:宋体; font-size:11pt">可将获取的上述信息用于：</span>
            </p>
            <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">1.对授权人资信状况进行风险评估与管理；</span>
            </p>
            <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">2.审核、审批、受理、办理授权人的贷款相关业务，包括但不限于授权人本人授信及贷款申请，以及授权人作为担保人或共同还款人、借款人的授信及贷款申请等；</span>
            </p>
            <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">3.在该业务存续期间检测本人的信用变化，进行贷后服务和管理；</span>
            </p>
            <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">4.开展市场调查与信息数据分析；</span>
            </p>
            <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">5.授权人申请征信异议处理；</span>
            </p>
            <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">6.依法或经有权部门要求；</span>
            </p>
            <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">7.其他经过本人同意的合法用途。</span>
            </p>
            <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:normal">五</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:normal">、本人同意并授权：</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">为了维护被授权人的合法权益，在本人逾期还款或者出现本人与</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">被授权人</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">签署的合同、协议、承诺或其他法律文件项下的违约时，</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">被授权人</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">可将本人的联系方式、联系地址及本人违约信息等信息公开，并根据欠款催收、债权转让、金融外包等需要将有关信息提供给</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">被授权人委托的催收机构、资产管理公司、外包公司等</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">第三方使用</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">，</span>
                <span style="font-family:宋体; font-size:11pt; font-style:normal; font-weight:bold; text-transform:none">具体</span>
                <span style="font-family:宋体; font-size:11pt; font-style:normal; font-weight:bold; text-transform:none">第三方</span>
                <span style="font-family:宋体; font-size:11pt; font-style:normal; font-weight:bold; text-transform:none">范围</span>
                <span style="font-family:宋体; font-size:11pt; font-style:normal; font-weight:bold; text-transform:none">、联系方式、处理目的、处理方式和个人信息种类等</span>
                <span style="font-family:宋体; font-size:11pt; font-style:normal; font-weight:bold; text-transform:none">以</span>
                <span style="font-family:宋体; font-size:11pt; font-style:normal; font-weight:bold; text-transform:none">被授权人网站</span>
                <span style="font-family:宋体; font-size:11pt; font-style:normal; font-weight:bold; text-transform:none">/APP或其他公开渠道</span>
                <span style="font-family:宋体; font-size:11pt; font-style:normal; font-weight:bold; text-transform:none">公布的名单为准</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">。</span>
            </p>
            <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:normal">六</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:normal">、本人同意并授权：</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">为便于向本人提供更加优质的服务和产品，本人授权</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">被授权人</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">可以将前述信息分享给与本人在</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">被授权人</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">办理业务相关的</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">被授权人</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">合作伙伴</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">，</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">具体合作伙伴范围、联系方式、处理目的、处理方式和个人信息种类等以被授权人网站/APP或其他公开渠道公布的名单为准</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">。</span>
            </p>
            <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
                <span style="font-family:宋体; font-size:11pt">七</span>
                <span style="font-family:宋体; font-size:11pt">、本人知悉，</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">被授权人</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">所获取的本人信息保存期限为【</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">5</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">】年。若因本人逾期还款等情形，</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">被授权人</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">于上述期限后仍有使用本人信息之必要的，本人同意并授权</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">被授权人</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">将本人的信息保存至上述情形消灭之日起【5】年。</span>
            </p>
            <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:normal">八、</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">本人声明：本授权书是本人向</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">被授权人</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">做出的单方承诺，且效力具有独立性，不因《借款额度合同》</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">、《借款合同》</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">等（以实际名称为准）</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">的任何条款无效而失效。</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">本授权书有效期自本授权书出具之日起至本人</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">或前述涉及到本人</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">在被授权人信贷业务</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">终结</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">之日止。如下情形视为本人与被授权人的业务未终结：本人在被授权人处有信贷余额或有授信额度；本人提供担保的授信业务有信贷余额或有授信额度。</span>
            </p>
            <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:normal">九</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:normal">、</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">若本人信贷业务未获批准，</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">则本授权书自动失效，授权自动终止。同时，本人</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">同意被授权人自行删除本人个人信息资料</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">，无须退回本人</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">。</span>
            </p>
            <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">十</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">、本人同意，因本人个人信息为被授权人进行风险评估及贷后管理所必须，因此，若本人撤回对被授权人的上述授权，则被授权人保留其停止发放贷款并要求授权人提前还贷的权利。</span>
            </p>
            <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">十一</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">、如果被授权人超出本授权书范围进行数据报送和查询使用，则被授权人应承担与此有关的法律责任。</span>
            </p>
            <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">十二</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">、若本人与以上被授权人发生任何纠纷或争议，首先应友好协商解决；协商不成的，本人同意将纠纷或争议提交本授权书签订地（即中国吉林省长春市南关区）有管辖权的人民法院管辖。本授权书的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。</span>
            </p>
            <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:normal">本人声明：本人同意本授权书以数据电文形式成立，自本人在线确认起即生效。</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">本人已经仔细阅读上述条款，并特别注意黑体字的内容，被授权人已应本人要求对相关条款予以明确说明。本人对所有条款的含义及相应的法律后果已全部通晓并充分理解，本人自愿作出上述授权、承诺和声明。</span>
            </p>
            <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">授权人：</span>
            </p>
            <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">身份证件号码：</span>
            </p>
            <p style="line-height:20pt; margin:0pt; orphans:0; text-indent:21.75pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">签署日期（授权书生效日期）：</span>
            </p>
        </div>

        <br/>
        <br/>

        <div style="text-align: left !important;">
            <p style="font-size:22pt; line-height:115%; margin:0pt 0pt 10pt; orphans:0; text-align:center; text-indent:44pt; widows:0">
                <span style="font-family:黑体; font-size:22pt">&#xa0;</span>
            </p>
            <p style="font-size:22pt; line-height:115%; margin:0pt 0pt 10pt; orphans:0; text-align:center; text-indent:44pt; widows:0">
                <span style="font-family:黑体; font-size:22pt">个人征信客户授权书</span>
            </p>
            <p style="line-height:22pt; margin:0pt 0pt 10pt; orphans:0; text-indent:28.1pt; widows:0">
                <span style="font-family:宋体; font-size:14pt; font-weight:bold">&#xa0;</span>
            </p>
            <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">尊敬的客户：</span>
            </p>
            <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:22.1pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">为了维护您的权益，请在签署本授权书前，仔细阅读本授权书各条款（特别是</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">黑体字条款），关注您在授权书中的权利、义务。</span>
            </p>
            <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:22.1pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">吉林亿联银行股份有限公司投诉咨询热线：</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">95396</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">。</span>
            </p>
            <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:22.1pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">百望股份有限公司</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">投诉咨询热线：</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">4008512366转9</span>
            </p>
            <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; widows:0">
                <span style="font-family:宋体; font-size:11pt">吉林亿联银行股份有限公司、</span>
                <span style="font-family:宋体; font-size:11pt">百望股份有限公司</span>
                <span style="font-family:宋体; font-size:11pt">（以下简称：被授权人）:</span>
            </p>
            <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; widows:0">
                <span style="font-family:宋体; font-size:11pt">一、本人同意并授权：被授权人按照《征信业管理条例》等国家相关规定采集并向中国人民银行金融信用信息基础数据库、百行征信有限公司、朴道征信有限公司报送本人个人信息及信用信息（包括但不限于信贷信息及对信息主体信用状况构成负面影响的不良信息）。</span>
            </p>
            <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:22pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:normal">二、本人同意并授权：被授权人可以根据国家有关规定，在办理涉及本人的信贷业务申请阶段及业务存续期间，</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">向中国人民银行金融信用信息基础数据库、百行征信有限公司、朴道征信有限公司查询、打印、保存本人的信用信息，并用于下述用途：</span>
            </p>
            <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:22.1pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:bold"></span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">审核本人授信及贷款申请；</span>
                <span style="width:4.09pt; text-indent:0pt; display:inline-block"></span>
                <span style="width:21pt; text-indent:0pt; display:inline-block"></span>
                <span style="width:21pt; text-indent:0pt; display:inline-block"></span>
            </p>
            <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:22.1pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:bold"></span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">审核本人作为其他个人、法人、其他组织机构办理信贷业务的担保人或相关还款责任人，包括事前审核和事后跟踪管理环节；</span>
            </p>
            <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:22.1pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:bold"></span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">对已发生的业务进行贷后风险管理；</span>
                <span style="width:2.09pt; text-indent:0pt; display:inline-block"></span>
                <span style="width:21pt; text-indent:0pt; display:inline-block"></span>
            </p>
            <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:22.1pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:bold"></span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">处理本人异议申请；</span>
            </p>
            <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:22.1pt; widows:0">
                <span style="font-family:微软雅黑; font-size:11pt; font-weight:bold">□</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">受理法人、其他组织机构的授信及贷款申请，或其作为担保人或相关还款责任人，需要查询其法定代表人、负责人等关联人的信用状况，包括事前审核和事后跟踪管理；</span>
            </p>
            <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:22pt; widows:0">
                <span style="font-family:宋体; font-size:11pt">本人知晓并同意被授权人有权向中国人民银行金融信用信息基础数据库核实本人资料、信息和记录，包括但不限于公积金、收入、社保、信用信息以及其他与本人有关的资料、信息和记录。</span>
            </p>
            <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:22pt; widows:0">
                <span style="font-family:宋体; font-size:11pt">3、</span>
                <span style="font-family:宋体; font-size:11pt">本人声明：本授权书是本人向贵行做出的单方承诺，且效力具有独立性，不因《借款额度合同》等其他协议条款的无效而失效。</span>
            </p>
            <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:22pt; widows:0">
                <span style="font-family:宋体; font-size:11pt">4、</span>
                <span style="font-family:宋体; font-size:11pt">本授权书有效期自本授权书出具之日起至本人或前述涉及到本人在被授权人信贷业务终结之日止。如下情形视为本人与被授权人的业务未终结：本人在被授权人处有信贷余额或有授信额度；本人提供担保的授信业务有信贷余额或有授信额度。</span>
            </p>
            <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:22.1pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">五、本人同意，因本人个人信息为被授权人进行风险评估及贷后管理所必须，因此，若本人撤回对被授权人的上述授权，则被授权人保留其停止发放贷款并要求授权人提前还贷的权利。</span>
            </p>
            <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:22pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:normal">六、本人知晓并同意若本人出现不良还款行为，被授权人可按照《征信业管理条例》要求，通过本人在业务办理过程中留存的联系信息，以短信、邮件、APPPUSH、语音等方式进行不良还款行为上报告知，</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">若因本人留存信息错误、发生变更、不良还款行为告知服务运营商网络不稳定或故障等客观因素，导致告知信息未触达或未及时触达本人的，将视为被授权人已履行告知义务。</span>
            </p>
            <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:22.1pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">七、本人已被明确告知不良还款信息一旦记录在中国人民银行金融信用信息基础数据库中，在日后的经济活动中对本人可能产生的不良影响。包括但不限于：将上述信息应用于对本人的信用评估或出具信用报告后，可能导致本人在申请某项业务时（如网络信贷），提供该等业务的机构因参考上述信用评估或信用报告而最终拒绝或终止向本人提供该等业务；以及虽采取了严格的符合国家认证标准的安全保护措施对所采集的上述信息实施了安全保护，但仍可能存在的因不可抗力或高科技本身所不可克服的漏洞或意外的恶意黑客攻击导致部分信息泄露的风险。</span>
            </p>
            <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:22.1pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">八、若本人信贷业务未获批准，</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">则本授权书自动失效，授权自动终止。同时，本人</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">同意被授权人自行删除本人个人</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">征信</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">资料，无须退回本人。</span>
            </p>
            <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:22.1pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">九、</span>
                <span style="font-family:宋体; font-size:11pt">如果被授权人超出本授权书范围进行数据报送和查询使用，则被授权人应承担与此有关的法律责任。</span>
            </p>
            <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:22.1pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">十、本授权书内容与相关业务的合同条款不一致的，无论相关合同在本授权书之前或之后签署，均应以本授权书的内容为准</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:normal">，</span>
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">但相关合同条款明确约定是针对本授权书内容所做修订的除外。</span>
            </p>
            <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:22.1pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">十一、本人知悉，被授权人所获取的本人征信信息保存期限为【5】年。若因本人逾期还款等情形，被授权人于上述期限后仍有使用本人信息之必要的，本人同意被授权人将本人的征信信息保存至上述情形消灭之日起【5】年。</span>
            </p>
            <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:22.1pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">十二、若本人与以上被授权人发生任何纠纷或争议，首先应友好协商解决；协商不成的，本人同意将纠纷或争议提交本授权书签订地（即中国吉林省长春市南关区）有管辖权的人民法院管辖。本授权书的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。</span>
            </p>
            <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:22.1pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">本人声明：本人已仔细阅读上述所有条款，并已特别注意字体加黑的内容，被授权人已应本人要求对相关条款予以明确说明。本人对所有条款的含义及相应的法律后果已全部通晓并充分理解，本人自愿作出上述授权、承诺和声明。</span>
            </p>
            <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:22.1pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">&#xa0;</span>
            </p>
            <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:22.1pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">授权人：</span>
            </p>
            <p style="line-height:20pt; margin:0pt 0pt 10pt; orphans:0; text-indent:22.1pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">身份证件号码：</span>
            </p>
            <p style="font-size:11pt; line-height:115%; margin:0pt 0pt 10pt; orphans:0; text-indent:22.1pt; widows:0">
                <span style="font-family:宋体; font-size:11pt; font-weight:bold">签署日期（授权书生效日期）：</span>
            </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FeildTwo',
  data() {
    return {};
  },
  props: {
    hidePopup: {
      type: Function,
      default: null,
    },
  },
  methods: {
    close() {
      this.hidePopup();
    },
  },
};
</script>
<style scoped>
.base_color{
  width: 100%;
  height: 100%;
}
.crossBox{
  text-align: right;
}
.cross{
  font-size: 20px;
}
#container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.clause{
  overflow: auto;
  background: #fff;
  background-size: contain;
}
* {
  /* width: 90%; */
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-size: 12px;
}
body {
  font-family: '微软雅黑';
}
.distance {
  text-align: left;

  /* margin-left: 10px; */
}
.distance_50 {
  letter-spacing: 0;
  text-align: left;
  text-indent: 6px;
}
.distance_80 {
  text-align: left;

  /* margin-left: 10px; */
}
p {
  margin-bottom: 8px;
}
#close {
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  height: 30px;
  padding-right: 10px;
  color: white;
  font-size: 20px;
  line-height: 30px;
  text-align: right;
  background: #3d4145;
}
</style>
